import request from '../../../shared/request'

// new ones
export function fetchJobSiteDocuments(params) {
  const qs = params.folderId ? `?folderId=${params.folderId}` : ''
  return request(`/job/job_site_documents/${params.jobId}/${qs}`)
}

// old ones
export function getJobSiteDocuments(job_id) {
  return request(`/job/job_site_documents/${job_id}/paths`)
}

export function createJobSiteDocument(payload) {
  return request(`/job/job_site_documents/${payload.job_id}/`, {
    method: 'POST',
    body: payload.file,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateJobSiteDocument(payload) {
  return request(`/job/job_site_documents/${payload.attachment_id}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteDocument(payload) {
  return request(
    `/job/job_site_documents/${payload.attachment_id}/attachment?jobId=${payload.jobId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  )
}

export function getJobSiteDocumentsS3(pathId) {
  return request(`/job/job_site_documents/${pathId}/s3`)
}

export function createFolder(payload) {
  return request(`/job/job_site_documents/${payload.jobId}/folder`, {
    method: 'POST',
    body: payload,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateFolder(payload) {
  return request(`/job/job_site_documents/${payload.folderId}/folder`, {
    method: 'PUT',
    body: payload,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function deleteFolder(payload) {
  return request(`/job/job_site_documents/${payload.folderId}/folder`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_documents/${payload.jobId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteDocuments.js